
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4ff2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fvZ0d", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $345299d1e09f8a21$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");

var $9kFno = parcelRequire("9kFno");

var $dpbtH = parcelRequire("dpbtH");

var $bNM0e = parcelRequire("bNM0e");

var $cFufl = parcelRequire("cFufl");

var $1yIrs = parcelRequire("1yIrs");

var $lkmjI = parcelRequire("lkmjI");

var $2MHzV = parcelRequire("2MHzV");

var $lfLTR = parcelRequire("lfLTR");

var $g9tzF = parcelRequire("g9tzF");

var $dTsuV = parcelRequire("dTsuV");

var $L57vH = parcelRequire("L57vH");

var $aZiU6 = parcelRequire("aZiU6");

var $d5ENn = parcelRequire("d5ENn");

var $gezfj = parcelRequire("gezfj");

var $5Iqkj = parcelRequire("5Iqkj");

var $2Aq2t = parcelRequire("2Aq2t");

const $345299d1e09f8a21$var$MdxContent = /*#__PURE__*/ (0, $9kFno.lazy)(()=>(parcelRequire("4MJHj")));
function $345299d1e09f8a21$var$DatasetsOverview() {
    const dataset = (0, $aZiU6.useDataset)((0, $2Aq2t.veda_faux_module_datasets));
    if (!dataset) throw (0, $1yIrs.resourceNotFound)();
    const taxonomies = dataset.data.taxonomy.filter((t)=>![
            (0, $L57vH.TAXONOMY_UNCERTAINTY),
            (0, $L57vH.TAXONOMY_GRADE)
        ].includes(t.name));
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $lkmjI.LayoutProps), {
                title: `${dataset.data.name} - Overview`,
                description: dataset.data.description,
                thumbnail: dataset.data.media?.src
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $2MHzV.PageMainContent), {
                children: [
                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $lfLTR.default), {
                        title: dataset.data.name,
                        description: dataset.data.description,
                        renderBetaBlock: ()=>/*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $2MHzV.PageActions), {
                                children: [
                                    dataset.data.disableExplore !== true && /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $bNM0e.Button), {
                                        forwardedAs: (0, $dpbtH.Link),
                                        to: (0, $d5ENn.getDatasetExplorePath)(dataset.data),
                                        size: "large",
                                        variation: "achromic-outline",
                                        children: [
                                            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonCompass), {}),
                                            "Explore data"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $dTsuV.NotebookConnectButton), {
                                        dataset: dataset.data,
                                        size: "large",
                                        compact: false,
                                        variation: "achromic-outline"
                                    })
                                ]
                            }),
                        renderDetailsBlock: ()=>/*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $gezfj.ContentTaxonomy), {
                                        taxonomy: taxonomies,
                                        linkBase: (0, $d5ENn.DATASETS_PATH)
                                    }),
                                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $5Iqkj.DatasetClassification), {
                                        dataset: dataset.data
                                    })
                                ]
                            }),
                        coverSrc: dataset.data.media?.src,
                        coverAlt: dataset.data.media?.alt,
                        attributionAuthor: dataset.data.media?.author?.name,
                        attributionUrl: dataset.data.media?.author?.url
                    }),
                    /*#__PURE__*/ (0, $iGQ0X.jsx)($345299d1e09f8a21$var$MdxContent, {
                        loader: dataset.content
                    }),
                    !!dataset.data.related?.length && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $g9tzF.default), {
                        related: dataset.data.related
                    })
                ]
            })
        ]
    });
}
var $345299d1e09f8a21$export$2e2bcd8739ae039 = $345299d1e09f8a21$var$DatasetsOverview;

});
parcelRegister("g9tzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0530cc511f9e1478$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $7mBN5 = parcelRequire("7mBN5");

var $iFxvA = parcelRequire("iFxvA");

var $gviJz = parcelRequire("gviJz");

var $9iiIw = parcelRequire("9iiIw");

var $d5ENn = parcelRequire("d5ENn");

var $8DoyF = parcelRequire("8DoyF");

var $azHi1 = parcelRequire("azHi1");

var $6RwH7 = parcelRequire("6RwH7");

var $lCGzm = parcelRequire("lCGzm");

var $eiMG9 = parcelRequire("eiMG9");
const $0530cc511f9e1478$var$datasetString = "dataset";
const $0530cc511f9e1478$var$storyString = "story";
const $0530cc511f9e1478$var$contentCategory = {
    [$0530cc511f9e1478$var$datasetString]: (0, $7mBN5.datasets),
    [$0530cc511f9e1478$var$storyString]: (0, $7mBN5.stories)
};
const $0530cc511f9e1478$var$TwoColumnCardList = (0, $1mmhu.default)((0, $azHi1.CardListGrid))`
  grid-template-columns: repeat(2, 1fr);
  margin-top: ${(0, $lCGzm.variableGlsp)(1)};
`;
const $0530cc511f9e1478$var$RelatedContentInner = (0, $1mmhu.default).div`
  grid-column: content-start / content-end;

  ${(0, $15X7d.media).largeUp`
  grid-column:  content-3 / content-11;
`}
`;
function $0530cc511f9e1478$var$formatUrl(id, parent) {
    switch(parent){
        case $0530cc511f9e1478$var$datasetString:
            return {
                parentLink: (0, $d5ENn.DATASETS_PATH),
                link: (0, $d5ENn.getDatasetPath)(id)
            };
        case $0530cc511f9e1478$var$storyString:
            return {
                parentLink: (0, $d5ENn.STORIES_PATH),
                link: (0, $d5ENn.getStoryPath)(id)
            };
        default:
            throw Error("Something went wrong with parent data of related content.");
    }
}
function $0530cc511f9e1478$var$formatBlock({ id: id, name: name, description: description, cardDescription: cardDescription, date: date, media: media, cardMedia: cardMedia, asLink: asLink, type: type }) {
    return {
        id: id,
        name: name,
        description: description,
        cardDescription: cardDescription,
        date: date,
        media: media,
        cardMedia: cardMedia,
        asLink: asLink,
        ...$0530cc511f9e1478$var$formatUrl(id, type),
        parent: type
    };
}
function $0530cc511f9e1478$var$formatContents(relatedData) {
    const rData = relatedData.map((relatedContent)=>{
        const { type: type, id: id } = relatedContent;
        // Even though type should be one of the defined values, this values comes
        // from user generated content and we can't be sure, so the checks are in
        // place.
        const matchingContent = $0530cc511f9e1478$var$contentCategory[type][id]?.data;
        if (!matchingContent) throw Error("Something went wrong. Check the related content frontmatter.");
        const { name: name, description: description, media: media, cardDescription: cardDescription, cardMedia: cardMedia } = matchingContent;
        return $0530cc511f9e1478$var$formatBlock({
            id: id,
            name: name,
            description: description,
            cardDescription: cardDescription,
            asLink: matchingContent.asLink,
            date: matchingContent.pubDate,
            media: media,
            cardMedia: cardMedia,
            type: type
        });
    });
    return rData;
}
function $0530cc511f9e1478$export$2e2bcd8739ae039(props) {
    const { related: related } = props;
    const relatedContents = $0530cc511f9e1478$var$formatContents(related);
    if (!relatedContents.length) throw Error("There is no related content defined.");
    return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $eiMG9.ContentBlock), {
        children: /*#__PURE__*/ (0, $iGQ0X.jsxs)($0530cc511f9e1478$var$RelatedContentInner, {
            children: [
                /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $6RwH7.FoldHeader), {
                    children: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $6RwH7.FoldTitle), {
                        children: "Related Content"
                    })
                }),
                /*#__PURE__*/ (0, $iGQ0X.jsx)($0530cc511f9e1478$var$TwoColumnCardList, {
                    children: relatedContents.map((t)=>/*#__PURE__*/ (0, $iGQ0X.jsx)("li", {
                            children: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $8DoyF.Card), {
                                cardType: (0, $8DoyF.CardType).COVER,
                                linkLabel: `View ${t.parent} ${t.name}`,
                                linkProperties: {
                                    linkTo: `${t.asLink?.url ?? t.link}`,
                                    LinkElement: (0, $iFxvA.default),
                                    pathAttributeKeyName: "to"
                                },
                                title: t.name,
                                date: t.parent === $0530cc511f9e1478$var$storyString ? (0, $9iiIw.utcString2userTzDate)(t.date) : undefined,
                                description: (0, $gviJz.getDescription)(t),
                                tagLabels: [
                                    t.parent
                                ],
                                parentTo: t.parentLink,
                                imgSrc: (0, $gviJz.getMediaProperty)(undefined, t, "src"),
                                imgAlt: (0, $gviJz.getMediaProperty)(undefined, t, "alt")
                            })
                        }, t.id))
                })
            ]
        })
    });
}

});
parcelRegister("gviJz", function(module, exports) {

$parcel$export(module.exports, "FilterActions", function () { return $f66504bbe1ef6122$export$f9efb216c86f7d6d; });
$parcel$export(module.exports, "onFilterAction", function () { return $f66504bbe1ef6122$export$af9874a55657e439; });
$parcel$export(module.exports, "getDescription", function () { return $f66504bbe1ef6122$export$67580b1c13935958; });
$parcel$export(module.exports, "getDatasetDescription", function () { return $f66504bbe1ef6122$export$3bf43e74e3e36c1d; });
$parcel$export(module.exports, "getMediaProperty", function () { return $f66504bbe1ef6122$export$b9185c423e2ed7fe; });

var $hhUjz = parcelRequire("hhUjz");

var $6ozbx = parcelRequire("6ozbx");
var $f66504bbe1ef6122$export$f9efb216c86f7d6d;
(function(FilterActions) {
    FilterActions["TAXONOMY_MULTISELECT"] = "taxonomy_multiselect";
    FilterActions["CLEAR"] = "clear";
    FilterActions["SEARCH"] = "search";
    FilterActions["SORT_FIELD"] = "sfield";
    FilterActions["SORT_DIR"] = "sdir";
    FilterActions["TAXONOMY"] = "taxonomy";
    FilterActions["CLEAR_TAXONOMY"] = "clear_taxonomy";
    FilterActions["CLEAR_SEARCH"] = "clear_search";
})($f66504bbe1ef6122$export$f9efb216c86f7d6d || ($f66504bbe1ef6122$export$f9efb216c86f7d6d = {}));
function $f66504bbe1ef6122$export$af9874a55657e439(action, value, taxonomies, setSearch, setTaxonomies) {
    switch(action){
        case "clear":
            setSearch("");
            setTaxonomies({});
            break;
        case "search":
            setSearch(value);
            break;
        case "clear_taxonomy":
            setTaxonomies({});
            break;
        case "clear_search":
            setSearch("");
            break;
        case "taxonomy":
            {
                const { key: key, value: val } = value;
                if (val === (0, $6ozbx.optionAll).id) setTaxonomies((0, $hhUjz.omit)(taxonomies, key));
                else setTaxonomies((0, $hhUjz.set)({
                    ...taxonomies
                }, key, val));
            }
            break;
        case "taxonomy_multiselect":
            {
                const { key: key, value: val } = value;
                if (taxonomies && key in taxonomies) {
                    const taxonomyGroupValues = taxonomies[key] instanceof Array ? taxonomies[key] : [
                        taxonomies[key]
                    ];
                    if (taxonomyGroupValues.includes(val)) {
                        const updatedValues = taxonomyGroupValues.filter((x)=>x !== val);
                        updatedValues.length ? setTaxonomies((0, $hhUjz.set)({
                            ...taxonomies
                        }, key, updatedValues)) : setTaxonomies((0, $hhUjz.omit)(taxonomies, key));
                    } else {
                        const updatedValues = [
                            ...taxonomyGroupValues,
                            val
                        ];
                        setTaxonomies((0, $hhUjz.set)({
                            ...taxonomies
                        }, key, updatedValues));
                    }
                } else setTaxonomies((0, $hhUjz.set)({
                    ...taxonomies
                }, key, [
                    val
                ]));
                break;
            }
        default:
            break;
    }
}
const $f66504bbe1ef6122$export$67580b1c13935958 = (data)=>{
    return data.cardDescription ?? data.description ?? "";
};
const $f66504bbe1ef6122$export$3bf43e74e3e36c1d = (layer, data)=>{
    if (!layer) return $f66504bbe1ef6122$export$67580b1c13935958(data);
    return $f66504bbe1ef6122$export$67580b1c13935958(layer);
};
const $f66504bbe1ef6122$export$b9185c423e2ed7fe = (layer, data, property)=>{
    return layer?.cardMedia?.[property] ?? layer?.media?.[property] ?? data.cardMedia?.[property] ?? data.media?.[property] ?? "";
};

});
parcelRegister("6ozbx", function(module, exports) {

$parcel$export(module.exports, "optionAll", function () { return $4a8047058aa9ddc4$export$f5136d9d0932b663; });
const $4a8047058aa9ddc4$export$f5136d9d0932b663 = {
    id: "all",
    name: "All"
};
const $4a8047058aa9ddc4$export$e46b93994e56d15a = 3;

});


parcelRegister("eiMG9", function(module, exports) {

$parcel$export(module.exports, "ContentBlock", function () { return $a69881c13c5c5eff$export$eb38b3b9c7f5f31b; });
$parcel$export(module.exports, "ContentBlockProse", function () { return $a69881c13c5c5eff$export$de2d73703e5451d1; });
$parcel$export(module.exports, "ContentBlockFigure", function () { return $a69881c13c5c5eff$export$ea5ac132c1b3abdd; });

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $lCGzm = parcelRequire("lCGzm");

var $hQDsC = parcelRequire("hQDsC");

var $beaRW = parcelRequire("beaRW");

var $cLnMM = parcelRequire("cLnMM");

var $fl59b = parcelRequire("fl59b");
const $a69881c13c5c5eff$export$eb38b3b9c7f5f31b = (0, $1mmhu.default)((0, $beaRW.default))`
  padding-top: ${(0, $lCGzm.variableGlsp)(2)};
  padding-bottom: ${(0, $lCGzm.variableGlsp)(2)};
  align-items: center;

  & + & {
    padding-top: 0;
  }
`;
const $a69881c13c5c5eff$export$de2d73703e5451d1 = (0, $1mmhu.default)((0, $hQDsC.VarProse))`
  gap: ${(0, $lCGzm.variableGlsp)()};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:first-child {
      column-span: all;
      max-width: 52rem;
      display: flex;
      flex-direction: column;
      gap: calc(${(0, $15X7d.glsp)()} - ${(0, $15X7d.glsp)(0.25)});
      margin-bottom: ${(0, $lCGzm.variableProseVSpace)()};

      &::before {
        content: '';
        width: ${(0, $15X7d.glsp)(2)};
        height: ${(0, $15X7d.glsp)(0.25)};
        border-radius: ${(0, $15X7d.themeVal)("shape.rounded")};
        background: ${(0, $15X7d.themeVal)("color.primary")};
      }
    }
  }

  * {
    break-inside: avoid;
  }

  ${(0, $cLnMM.FigcaptionInner)} {
    padding: ${(0, $15X7d.glsp)(1, 0, 0, 0)};

    &::after {
      display: none;
    }
  }

  ${(0, $cLnMM.FigureAttributionSelf)} {
    top: ${(0, $15X7d.glsp)()};
    right: ${(0, $15X7d.glsp)()};
  }

  [class*='align-'] {
    figcaption {
      padding: 0;
    }
  }

  .align-left {
    float: left;
    margin-right: ${(0, $lCGzm.variableProseVSpace)()};
  }

  .align-right {
    float: right;
    margin-left: ${(0, $lCGzm.variableProseVSpace)()};

    ${(0, $cLnMM.FigcaptionInner)} {
      align-items: end;
      text-align: right;
    }
  }

  .align-center {
    margin-left: 50%;
    transform: translate(-50%, 0);

    ${(0, $cLnMM.FigcaptionInner)} {
      align-items: center;
      text-align: center;
    }
  }

  .img-align-right {
    margin-left: auto;
  }

  .img-align-center {
    margin-left: auto;
    margin-right: auto;
  }
`;
// assign displayName that a block can tell
$a69881c13c5c5eff$export$de2d73703e5451d1.displayName = (0, $fl59b.proseDisplayName);
const $a69881c13c5c5eff$export$ea5ac132c1b3abdd = (0, $1mmhu.default)((0, $cLnMM.Figure))`
  img {
    width: 100%;
  }
`;

});
parcelRegister("fl59b", function(module, exports) {

$parcel$export(module.exports, "defaultBlockName", function () { return $b2accf48a191e6f6$export$118614607e8dcf65; });
$parcel$export(module.exports, "wideBlockName", function () { return $b2accf48a191e6f6$export$38b0a766c9dac22; });
$parcel$export(module.exports, "fullBlockName", function () { return $b2accf48a191e6f6$export$a84e006e74141e5e; });
$parcel$export(module.exports, "generalErrorMessage", function () { return $b2accf48a191e6f6$export$10f2923c441284d; });
$parcel$export(module.exports, "blockTypeErrorMessage", function () { return $b2accf48a191e6f6$export$c0dcfd7ed4b165c1; });
$parcel$export(module.exports, "contentTypeErrorMessage", function () { return $b2accf48a191e6f6$export$9449ede1c1bd8740; });
$parcel$export(module.exports, "figureDisplayName", function () { return $b2accf48a191e6f6$export$7940ebc7f9f1a73d; });
$parcel$export(module.exports, "proseDisplayName", function () { return $b2accf48a191e6f6$export$6a526ca7ff83cb40; });
$parcel$export(module.exports, "captionDisplayName", function () { return $b2accf48a191e6f6$export$31a06e30ce68717; });
const $b2accf48a191e6f6$export$118614607e8dcf65 = "default";
const $b2accf48a191e6f6$export$38b0a766c9dac22 = "wide";
const $b2accf48a191e6f6$export$a84e006e74141e5e = "full";
const $b2accf48a191e6f6$export$10f2923c441284d = "There is an error in this block";
const $b2accf48a191e6f6$export$c0dcfd7ed4b165c1 = "We do not support block type";
const $b2accf48a191e6f6$export$9449ede1c1bd8740 = "We do not support this composition of contents";
const $b2accf48a191e6f6$export$7940ebc7f9f1a73d = "Figure";
const $b2accf48a191e6f6$export$6a526ca7ff83cb40 = "Prose";
const $b2accf48a191e6f6$export$31a06e30ce68717 = "Caption";

});



parcelRegister("dTsuV", function(module, exports) {

$parcel$export(module.exports, "NotebookConnectModal", function () { return $78296b1679821f7e$export$1866d6992a79a72a; });
$parcel$export(module.exports, "NotebookConnectButton", function () { return $78296b1679821f7e$export$3ddf9ca7b41c0f7c; });
$parcel$export(module.exports, "NotebookConnectCalloutBlock", function () { return $78296b1679821f7e$export$109c5c5bc7d581c0; });

var $iGQ0X = parcelRequire("iGQ0X");

var $9kFno = parcelRequire("9kFno");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $bNM0e = parcelRequire("bNM0e");

var $cFufl = parcelRequire("cFufl");

var $510uG = parcelRequire("510uG");

var $7mBN5 = parcelRequire("7mBN5");

var $hKxgq = parcelRequire("hKxgq");

var $lCGzm = parcelRequire("lCGzm");
const $78296b1679821f7e$var$DatasetUsages = (0, $1mmhu.default).ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${(0, $lCGzm.variableGlsp)()};
  margin-bottom: ${(0, $lCGzm.variableGlsp)()};
  list-style-type: none;
  padding: 0;

  ${(0, $15X7d.media).smallUp`
    grid-template-columns: 1fr 1fr;
  `}
`;
const $78296b1679821f7e$var$DatasetUsageLink = (0, $1mmhu.default).a`
  display: flex;
  padding: ${(0, $lCGzm.variableGlsp)()};
  text-decoration: none;
  color: ${(0, $15X7d.themeVal)("color.primary")};
  border-radius: ${(0, $15X7d.themeVal)("shape.rounded")};
  background: ${(0, $15X7d.themeVal)("color.primary-50")};
  outline: 0 solid transparent;
  transition: transform 0.24s ease-in-out 0s, outline-width 0.16s ease-in-out 0s;

  & > svg {
    flex: 0 0 auto;
    margin: 0.25rem 0.5rem 0 0;
  }

  &:visited {
    color: ${(0, $15X7d.themeVal)("color.primary")};
  }

  &:hover {
    transform: translate(0, 0.125rem);
  }

  &:focus-visible {
    outline-width: 0.25rem;
    outline-color: ${(0, $15X7d.themeVal)("color.primary")};
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }
`;
const $78296b1679821f7e$var$DatasetUsageLabel = (0, $1mmhu.default).div`
  & > h4 {
    font-weight: normal;
  }

  & > p {
    color: ${(0, $15X7d.themeVal)("color.base")};
    font-size: 0.875rem;
  }
`;
const $78296b1679821f7e$var$IconByType = {
    jupyter: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonCog), {}),
    github: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonBook), {}),
    download: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonDownload2), {}),
    unknown: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonCog), {})
};
function $78296b1679821f7e$export$1866d6992a79a72a(props) {
    const { dataset: dataset, revealed: revealed, onClose: onClose } = props;
    const datasetUsages = dataset?.usage;
    const datasetUsagesWithIcon = (0, $9kFno.useMemo)(()=>{
        return datasetUsages?.map((d)=>{
            let type = "unknown";
            if (d.url.match("nasa-veda.2i2c.cloud")) type = "jupyter";
            else if (d.url.match("github.com/NASA-IMPACT/veda-docs")) type = "github";
            else if (d.url.match("browseui")) type = "download";
            return {
                ...d,
                type: type
            };
        });
    }, [
        datasetUsages
    ]);
    if (!datasetUsages || !datasetUsagesWithIcon) return null;
    const layerIdsSet = dataset.layers.reduce((acc, layer)=>acc.add(layer.stacCol), new Set());
    return /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $510uG.Modal), {
        id: "modal",
        size: "medium",
        title: "How to use this dataset",
        revealed: revealed,
        onCloseClick: onClose,
        onOverlayClick: onClose,
        closeButton: true,
        content: /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iGQ0X.jsx)($78296b1679821f7e$var$DatasetUsages, {
                    children: datasetUsagesWithIcon.map((datasetUsage)=>/*#__PURE__*/ (0, $iGQ0X.jsx)("li", {
                            children: /*#__PURE__*/ (0, $iGQ0X.jsxs)($78296b1679821f7e$var$DatasetUsageLink, {
                                href: datasetUsage.url,
                                target: "_blank",
                                rel: "noopener",
                                children: [
                                    $78296b1679821f7e$var$IconByType[datasetUsage.type],
                                    /*#__PURE__*/ (0, $iGQ0X.jsxs)($78296b1679821f7e$var$DatasetUsageLabel, {
                                        children: [
                                            /*#__PURE__*/ (0, $iGQ0X.jsx)("h4", {
                                                children: datasetUsage.title
                                            }),
                                            /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                                                children: datasetUsage.label
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, datasetUsage.url))
                }),
                /*#__PURE__*/ (0, $iGQ0X.jsx)("p", {
                    children: "For reference, the following STAC collection ID's are associated with this dataset:"
                }),
                /*#__PURE__*/ (0, $iGQ0X.jsx)("ul", {
                    children: Array.from(layerIdsSet).map((id)=>/*#__PURE__*/ (0, $iGQ0X.jsx)("li", {
                            children: /*#__PURE__*/ (0, $iGQ0X.jsx)("code", {
                                children: id
                            })
                        }, id))
                })
            ]
        })
    });
}
function $78296b1679821f7e$var$NotebookConnectButtonSelf(props) {
    const { className: className, compact: compact = true, variation: variation = "primary-fill", size: size = "medium", dataset: dataset } = props;
    const [revealed, setRevealed] = (0, $9kFno.useState)(false);
    const close = (0, $9kFno.useCallback)(()=>setRevealed(false), []);
    const datasetUsages = dataset?.usage;
    if (!datasetUsages) return null;
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $iGQ0X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $bNM0e.Button), {
                className: className,
                type: "button",
                variation: variation,
                fitting: compact ? "skinny" : "regular",
                onClick: ()=>setRevealed(true),
                size: size,
                children: [
                    /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cFufl.CollecticonCode), {
                        meaningful: compact,
                        title: "Open data usage options"
                    }),
                    compact ? "" : "Access Data"
                ]
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)($78296b1679821f7e$export$1866d6992a79a72a, {
                dataset: dataset,
                revealed: revealed,
                onClose: close
            })
        ]
    });
}
const $78296b1679821f7e$export$3ddf9ca7b41c0f7c = (0, $1mmhu.default)($78296b1679821f7e$var$NotebookConnectButtonSelf)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
`;
function $78296b1679821f7e$var$NotebookConnectCalloutSelf(props) {
    const { children: children, datasetId: datasetId, className: className } = props;
    if (!datasetId) throw new (0, $hKxgq.HintedError)("Malformed Map Block", [
        "Missing property: datasetId"
    ]);
    const dataset = (0, $7mBN5.datasets)[datasetId];
    if (!dataset) throw new (0, $hKxgq.HintedError)("Malformed Map Block", [
        `Dataset not found: ${datasetId}`
    ]);
    if (!dataset.data.usage?.length) throw new (0, $hKxgq.HintedError)("Malformed Map Block", [
        `Dataset does not have 'usage' defined: ${datasetId}`
    ]);
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("div", {
                children: children
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)($78296b1679821f7e$export$3ddf9ca7b41c0f7c, {
                // compact={false}
                variation: "base-outline",
                dataset: dataset.data
            })
        ]
    });
}
const $78296b1679821f7e$export$109c5c5bc7d581c0 = (0, $1mmhu.default)($78296b1679821f7e$var$NotebookConnectCalloutSelf)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
  display: flex;
  flex-flow: row nowrap;
  border-radius: ${(0, $15X7d.multiply)((0, $15X7d.themeVal)("shape.rounded"), 2)};
  background: ${(0, $15X7d.themeVal)("color.base-50")};
  padding: ${(0, $lCGzm.variableGlsp)()};
  gap: ${(0, $lCGzm.variableGlsp)()};
  box-shadow: inset 0 -1px 0 0 ${(0, $15X7d.themeVal)("color.base-50a")};

  ${$78296b1679821f7e$export$3ddf9ca7b41c0f7c} {
    margin-left: auto;
  }
`;

});

parcelRegister("L57vH", function(module, exports) {

$parcel$export(module.exports, "generateTaxonomies", function () { return $fe3b756467e8d5fe$export$169842684a0b1048; });
$parcel$export(module.exports, "TAXONOMY_TOPICS", function () { return $fe3b756467e8d5fe$export$d101bd2158e5168d; });
$parcel$export(module.exports, "TAXONOMY_SOURCE", function () { return $fe3b756467e8d5fe$export$d4f4f1e55b8a9393; });
$parcel$export(module.exports, "TAXONOMY_GRADE", function () { return $fe3b756467e8d5fe$export$7dcd5643bc2d64d8; });
$parcel$export(module.exports, "TAXONOMY_UNCERTAINTY", function () { return $fe3b756467e8d5fe$export$c6dd31dcfd3be20b; });
$parcel$export(module.exports, "getTaxonomy", function () { return $fe3b756467e8d5fe$export$6c3855d1405cdf74; });
$parcel$export(module.exports, "getAllTaxonomyValues", function () { return $fe3b756467e8d5fe$export$d7c8b3df777589c6; });
$parcel$export(module.exports, "getTaxonomyByIds", function () { return $fe3b756467e8d5fe$export$3b9206893354b380; });

var $hhUjz = parcelRequire("hhUjz");
function $fe3b756467e8d5fe$export$169842684a0b1048(data) {
    const concat = (arr, v)=>(arr || []).concat(v);
    const taxonomyData = {};
    // for loops are faster than reduces.
    for (const { taxonomy: taxonomy } of data)for (const { name: name, values: values } of taxonomy){
        if (!name || !values.length) continue;
        taxonomyData[name] = concat(taxonomyData[name], values);
    }
    const taxonomiesUnique = Object.entries(taxonomyData).map(([key, tx])=>({
            name: key,
            // eslint-disable-next-line fp/no-mutating-methods
            values: (0, $hhUjz.uniqBy)(tx, (t)=>t.id).sort((a, b)=>a.name.localeCompare(b.name))
        }));
    return taxonomiesUnique;
}
const $fe3b756467e8d5fe$export$d101bd2158e5168d = "Topics";
const $fe3b756467e8d5fe$export$d4f4f1e55b8a9393 = "Source";
const $fe3b756467e8d5fe$export$7dcd5643bc2d64d8 = "Grade";
const $fe3b756467e8d5fe$export$c6dd31dcfd3be20b = "Uncertainty";
function $fe3b756467e8d5fe$export$6c3855d1405cdf74(data, taxonomyName) {
    const list = Array.isArray(data) ? data : data.taxonomy;
    return list.find((t)=>t.name === taxonomyName);
}
function $fe3b756467e8d5fe$export$d7c8b3df777589c6(data) {
    const list = Array.isArray(data) ? data : data.taxonomy;
    const allValues = list.map((l)=>l.values).flat();
    return allValues;
}
function $fe3b756467e8d5fe$export$3b9206893354b380(group, ids, taxonomies) {
    const groupValues = taxonomies.find((t)=>t.name == group)?.values;
    let taxonomyItems = [];
    if (ids instanceof Array) {
        const items = ids.map((id)=>groupValues?.filter((value)=>value.id == id)[0]);
        taxonomyItems = items.map((item)=>({
                ...item,
                taxonomy: group
            }));
    } else {
        const taxonomy = groupValues?.filter((value)=>value.id == ids)[0];
        /* eslint-disable-next-line fp/no-mutating-methods */ if (taxonomy) taxonomyItems.push({
            ...taxonomy,
            taxonomy: group
        });
    }
    return taxonomyItems;
}

});

parcelRegister("aZiU6", function(module, exports) {

$parcel$export(module.exports, "getAllDatasetsProps", function () { return $f7fd21d492c31914$export$c87b6f0d1fad0eeb; });
$parcel$export(module.exports, "useStory", function () { return $f7fd21d492c31914$export$3ee30d5a4184e73f; });
$parcel$export(module.exports, "useDataset", function () { return $f7fd21d492c31914$export$1aafb48d4543fc87; });

var $iyi84 = parcelRequire("iyi84");
const $f7fd21d492c31914$export$c87b6f0d1fad0eeb = (datasets)=>Object.values(datasets).map((d)=>d.data);
const $f7fd21d492c31914$export$c7367db99bb49289 = (stories)=>Object.values(stories).map((d)=>d.data);
function $f7fd21d492c31914$export$3ee30d5a4184e73f(stories) {
    const { storyId: storyId } = (0, $iyi84.useParams)();
    const story = stories[storyId ?? ""];
    // Stop if the story doesn't exist.
    return story ?? null;
}
function $f7fd21d492c31914$export$1aafb48d4543fc87(datasets) {
    const { datasetId: datasetId } = (0, $iyi84.useParams)();
    const dataset = datasets[datasetId ?? ""];
    // Stop if the datasets doesn't exist.
    return dataset ?? null;
}

});

parcelRegister("gezfj", function(module, exports) {

$parcel$export(module.exports, "ContentTaxonomy", function () { return $bdada55c6cc67c07$export$946dfc2749acba8b; });

var $iGQ0X = parcelRequire("iGQ0X");

var $9kFno = parcelRequire("9kFno");

var $1mmhu = parcelRequire("1mmhu");

var $dpbtH = parcelRequire("dpbtH");

var $15X7d = parcelRequire("15X7d");

var $cvsoH = parcelRequire("cvsoH");

var $gviJz = parcelRequire("gviJz");

var $lCGzm = parcelRequire("lCGzm");

var $fcETu = parcelRequire("fcETu");
const $bdada55c6cc67c07$var$TaxonomySection = (0, $1mmhu.default).section`
  grid-column: 1 / -1;
  margin-left: ${(0, $lCGzm.variableGlsp)(-1)};
  margin-right: ${(0, $lCGzm.variableGlsp)(-1)};
  padding: ${(0, $lCGzm.variableGlsp)(1, 1, 0, 1)};
  box-shadow: 0 -1px 0 0 ${(0, $15X7d.themeVal)("color.surface-200a")};
`;
const $bdada55c6cc67c07$var$TaxonomyList = (0, $1mmhu.default).dl`
  grid-column: 1 / -1;
  display: flex;
  flex-flow: row wrap;
  gap: ${(0, $15X7d.glsp)(0.5)};
  align-items: center;

  > dd {
    display: flex;
    flex-flow: row wrap;
    gap: ${(0, $15X7d.glsp)(0.5)};
    margin-right: ${(0, $15X7d.glsp)(0.5)};
  }
`;
function $bdada55c6cc67c07$export$946dfc2749acba8b(props) {
    const { taxonomy: taxonomy, linkBase: linkBase } = props;
    if (!taxonomy.length) return null;
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)($bdada55c6cc67c07$var$TaxonomySection, {
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cvsoH.Heading), {
                as: "h2",
                hidden: true,
                children: "Taxonomy"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)($bdada55c6cc67c07$var$TaxonomyList, {
                children: taxonomy.map(({ name: name, values: values })=>/*#__PURE__*/ (0, $iGQ0X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($9kFno))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $iGQ0X.jsx)("dt", {
                                children: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $cvsoH.Overline), {
                                    variation: "surface-400a",
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0, $iGQ0X.jsx)("dd", {
                                children: values.map((t)=>/*#__PURE__*/ (0, $iGQ0X.jsx)((0, $fcETu.Pill), {
                                        variation: "achromic",
                                        as: (0, $dpbtH.Link),
                                        to: `${linkBase}?${(0, $gviJz.FilterActions).TAXONOMY}=${encodeURIComponent(JSON.stringify({
                                            [name]: t.id
                                        }))}`,
                                        children: t.name
                                    }, t.id))
                            })
                        ]
                    }, name))
            })
        ]
    });
}

});

parcelRegister("5Iqkj", function(module, exports) {

$parcel$export(module.exports, "DatasetClassification", function () { return $25a85ce88a6140e3$export$8995c29291ad3af8; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $1mmhu = parcelRequire("1mmhu");

var $15X7d = parcelRequire("15X7d");

var $1pWd5 = parcelRequire("1pWd5");

var $lTc8j = parcelRequire("lTc8j");

var $1lR3a = parcelRequire("1lR3a");

var $2tzgv = parcelRequire("2tzgv");

var $lCGzm = parcelRequire("lCGzm");

var $L57vH = parcelRequire("L57vH");
const $25a85ce88a6140e3$var$DATA_UNCERTAINTY = {
    High: (0, $lTc8j.CollecticonProgressTickLow),
    Medium: (0, $lTc8j.CollecticonProgressTickMedium),
    Low: (0, $lTc8j.CollecticonProgressTickHigh)
};
const $25a85ce88a6140e3$var$DATA_GRADE = {
    Research: (0, $1lR3a.CollecticonFlask),
    "Agency standard/regulatory": (0, $2tzgv.CollecticonMedal)
};
const $25a85ce88a6140e3$var$DatasetClassificationWrapper = (0, $1mmhu.default).div`
  position: absolute;
  top: ${(0, $lCGzm.variableGlsp)()};
  left: ${(0, $lCGzm.variableGlsp)()};
  display: flex;
  gap: ${(0, $15X7d.glsp)(0.5)};

  svg {
    pointer-events: all;
    color: ${(0, $15X7d.themeVal)("color.surface")};
  }
`;
function $25a85ce88a6140e3$export$8995c29291ad3af8(props) {
    const { dataset: dataset } = props;
    const grade = (0, $L57vH.getTaxonomy)(dataset, (0, $L57vH.TAXONOMY_GRADE))?.values[0];
    const uncertainty = (0, $L57vH.getTaxonomy)(dataset, (0, $L57vH.TAXONOMY_UNCERTAINTY))?.values[0];
    const IconUncertainty = $25a85ce88a6140e3$var$DATA_UNCERTAINTY[uncertainty?.name ?? ""];
    const IconGrade = $25a85ce88a6140e3$var$DATA_GRADE[grade?.name ?? ""];
    if (!IconUncertainty && !IconGrade) return null;
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)($25a85ce88a6140e3$var$DatasetClassificationWrapper, {
        children: [
            IconUncertainty && uncertainty && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1pWd5.Tip), {
                content: `Uncertainty: ${uncertainty.name}`,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)(IconUncertainty, {
                    meaningful: true,
                    title: `Uncertainty: ${uncertainty.name}`
                })
            }),
            IconGrade && grade && /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1pWd5.Tip), {
                content: `Grade: ${grade.name}`,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)(IconGrade, {
                    meaningful: true,
                    title: `Grade: ${grade.name}`
                })
            })
        ]
    });
}

});
parcelRegister("lTc8j", function(module, exports) {

$parcel$export(module.exports, "CollecticonProgressTickHigh", function () { return $186d43563bb7f0d7$export$1a26968bd5e528c1; });
$parcel$export(module.exports, "CollecticonProgressTickMedium", function () { return $186d43563bb7f0d7$export$e936722be7af186a; });
$parcel$export(module.exports, "CollecticonProgressTickLow", function () { return $186d43563bb7f0d7$export$bf479e9952d124c2; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $cFufl = parcelRequire("cFufl");

var $1mmhu = parcelRequire("1mmhu");
const $186d43563bb7f0d7$export$1a26968bd5e528c1 = (0, $1mmhu.default)((0, $cFufl.createCollecticon)((props)=>/*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("title", {
                children: props.title || "A progress tick high icon"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M15.938,9L13.918,9C13.713,10.223 13.136,11.349 12.244,12.244C11.109,13.375 9.603,14 8,14C6.397,14 4.891,13.375 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C3.834,3.678 3.916,3.6 4,3.528L4,6L6,6L6,-0L0,0L0,2L2.709,2C1.047,3.466 0,5.609 0,8C0,12.419 3.581,16 8,16C12.081,16 15.446,12.947 15.938,9ZM10.784,4.916L12.269,6.253L7.1,12L3.856,8.794L5.262,7.372L7.016,9.103L10.784,4.916ZM14.32,3.094L12.893,4.521C13.42,5.26 13.769,6.104 13.918,7L15.938,7C15.756,5.539 15.18,4.201 14.32,3.094ZM11.478,3.108L12.906,1.68C11.551,0.627 9.849,-0 8,-0L8,2C9.264,2 10.469,2.388 11.478,3.108Z"
            })
        ]
    })))`
  /* icons must be styled-components */
`;
const $186d43563bb7f0d7$export$e936722be7af186a = (0, $1mmhu.default)((0, $cFufl.createCollecticon)((props)=>/*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("title", {
                children: props.title || "A progress tick medium icon"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M7,15.938L7,13.918C5.777,13.713 4.651,13.136 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C3.834,3.678 3.916,3.6 4,3.528L4,6L6,6L6,-0L0,0L0,2L2.709,2C1.047,3.466 0,5.609 0,8C0,12.081 3.053,15.446 7,15.938ZM11.478,12.892C10.739,13.419 9.895,13.768 9,13.918L9,15.938C10.461,15.756 11.799,15.18 12.906,14.32L11.478,12.892ZM15.938,9L13.918,9C13.768,9.895 13.419,10.739 12.892,11.478L14.32,12.906C15.18,11.8 15.756,10.461 15.938,9ZM10.784,4.916L12.269,6.253L7.1,12L3.856,8.794L5.262,7.372L7.016,9.103L10.784,4.916ZM14.32,3.094L12.893,4.521C13.42,5.26 13.769,6.104 13.918,7L15.938,7C15.756,5.539 15.18,4.201 14.32,3.094ZM11.478,3.108L12.906,1.68C11.551,0.627 9.849,-0 8,-0L8,2C9.264,2 10.469,2.388 11.478,3.108Z"
            })
        ]
    })))`
  /* icons must be styled-components */
`;
const $186d43563bb7f0d7$export$bf479e9952d124c2 = (0, $1mmhu.default)((0, $cFufl.createCollecticon)((props)=>/*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("title", {
                children: props.title || "A progress tick high icon"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                d: "M4.522,12.892L3.094,14.32C4.2,15.18 5.539,15.756 7,15.938L7,13.918C6.105,13.768 5.261,13.419 4.522,12.892ZM11.478,12.892C10.739,13.419 9.895,13.768 9,13.918L9,15.938C10.461,15.756 11.799,15.18 12.906,14.32L11.478,12.892ZM13.918,9C13.768,9.895 13.419,10.739 12.892,11.478L14.32,12.906C15.18,11.8 15.756,10.461 15.938,9L13.918,9ZM2.082,9L0.062,9C0.244,10.461 0.82,11.799 1.68,12.906L3.108,11.478C2.581,10.739 2.232,9.895 2.082,9ZM10.784,4.916L12.269,6.253L7.1,12L3.856,8.794L5.262,7.372L7.016,9.103L10.784,4.916ZM14.32,3.094L12.893,4.521C13.42,5.26 13.769,6.104 13.918,7L15.938,7C15.756,5.539 15.18,4.201 14.32,3.094ZM0.062,7L2.082,7C2.287,5.777 2.864,4.651 3.756,3.756C3.834,3.678 3.916,3.6 4,3.528L4,6L6,6L6,-0L0,0L0,2L2.709,2C1.283,3.258 0.309,5.015 0.062,7ZM11.478,3.108L12.906,1.68C11.551,0.627 9.849,-0 8,-0L8,2C9.264,2 10.469,2.388 11.478,3.108Z"
            })
        ]
    })))`
  /* icons must be styled-components */
`;

});

parcelRegister("1lR3a", function(module, exports) {

$parcel$export(module.exports, "CollecticonFlask", function () { return $bd0a51d6377f0335$export$5c5e312ef0488786; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $cFufl = parcelRequire("cFufl");

var $1mmhu = parcelRequire("1mmhu");
const $bd0a51d6377f0335$export$5c5e312ef0488786 = (0, $1mmhu.default)((0, $cFufl.createCollecticon)((props)=>/*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("title", {
                children: props.title || "A flask icon"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                id: "lab-flask",
                d: "M5,2L5,6C5,6 2.583,10.028 0.817,12.971C0.447,13.589 0.437,14.358 0.792,14.985C1.147,15.612 1.812,16 2.532,16C5.694,16 10.306,16 13.468,16C14.188,16 14.853,15.612 15.208,14.985C15.563,14.358 15.553,13.589 15.183,12.971C13.417,10.028 11,6 11,6L11,2L12,2L12,0L4,0L4,2L5,2ZM11.068,10L4.932,10L7,6.554L7,2L9,2C9,2 9,6.554 9,6.554L11.068,10Z"
            })
        ]
    })))`
  /* icons must be styled-components */
`;

});

parcelRegister("2tzgv", function(module, exports) {

$parcel$export(module.exports, "CollecticonMedal", function () { return $304a5aa44d309db5$export$41cf3a9d8250975e; });

var $iGQ0X = parcelRequire("iGQ0X");
parcelRequire("9kFno");

var $cFufl = parcelRequire("cFufl");

var $1mmhu = parcelRequire("1mmhu");
const $304a5aa44d309db5$export$41cf3a9d8250975e = (0, $1mmhu.default)((0, $cFufl.createCollecticon)((props)=>/*#__PURE__*/ (0, $iGQ0X.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)("title", {
                children: props.title || "A medal icon"
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)("path", {
                id: "medal",
                d: "M4,10.471L4,16L8,14L12,16L12,10.471C13.227,9.372 14,7.775 14,6C14,2.689 11.311,0 8,0C4.689,0 2,2.689 2,6C2,7.775 2.773,9.372 4,10.471ZM8,3C9.656,3 11,4.344 11,6C11,7.656 9.656,9 8,9C6.344,9 5,7.656 5,6C5,4.344 6.344,3 8,3Z"
            })
        ]
    })))`
  /* icons must be styled-components */
`;

});


parcelRegister("2Aq2t", function(module, exports) {

$parcel$export(module.exports, "veda_faux_module_datasets", function () { return $9a0c5b528f329df8$export$255f2c618812acab; });
$parcel$export(module.exports, "veda_faux_module_stories", function () { return $9a0c5b528f329df8$export$394c009f792e3052; });
$parcel$export(module.exports, "allExploreDatasets", function () { return $9a0c5b528f329df8$export$17b44589b4c203ee; });

var $7mBN5 = parcelRequire("7mBN5");
const $9a0c5b528f329df8$export$255f2c618812acab = (0, $7mBN5.datasets);
const $9a0c5b528f329df8$export$394c009f792e3052 = (0, $7mBN5.stories);
const $9a0c5b528f329df8$export$17b44589b4c203ee = Object.values($9a0c5b528f329df8$export$255f2c618812acab).map((d)=>d.data).filter((d)=>!d.disableExplore);

});

parcelRegister("4MJHj", function(module, exports) {

var $YH53S = parcelRequire("YH53S");


module.exports = Promise.all([
    $YH53S("2yOkk"),
    $YH53S("jW3aV"),
    (parcelRequire("bwR2h"))((parcelRequire("c2ZQb")).resolve("BIi6A")),
    $YH53S("51tT2"),
    $YH53S("45qFt"),
    $YH53S("epbdb"),
    $YH53S("cODCh"),
    $YH53S("4caxt")
]).then(()=>parcelRequire("9Ev3U"));

});



//# sourceMappingURL=s-overview.c1c9a79b.js.map
